import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Import utilities
import { getAllowedPermissions } from "utils/authentication";
import sideBarBuilder from 'utils/sideBarBuilder';

const Sidebar = () => {
  
  const { pathname } = useLocation();

  const { userInfo } = useSelector((state) => state.auth);

  const userPermissions = getAllowedPermissions(userInfo);

  const sideBarData = sideBarBuilder(userPermissions);

  return (
    <aside id="sidebar" className="sidebar">
      <Nav className="sidebar-nav d-flex flex-column" id="sidebar-nav">
        {sideBarData.map((item, index) => (
          <Nav.Item key={index}>
            <Nav.Link
              as={NavLink}
              to={item.path}
              exact="true"
              className={pathname === item.path ? "active" : "collapsed"}
            >
              <i className={item.icon}></i>
              <span>{item.name}</span>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </aside>
  );
};

export default Sidebar;
